import { useEffect } from 'react';

const MARK = 'data-modamai-api-seo';

/**
 * Applies canonical + hreflang from API only (no path guessing).
 * @param {{ canonicalUrl?: string, hreflangAlternates?: { hreflang: string, href: string }[], hreflangLanguages?: Record<string, string> }} props
 */
export default function ApiLocaleSeo({ canonicalUrl, hreflangAlternates, hreflangLanguages }) {
  useEffect(() => {
    document.querySelectorAll(`head [${MARK}="1"]`).forEach((el) => el.remove());

    const canonical = canonicalUrl != null ? String(canonicalUrl).trim() : '';
    if (!canonical) return undefined;

    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonical);
    link.setAttribute(MARK, '1');
    document.head.appendChild(link);

    const og = document.createElement('meta');
    og.setAttribute('property', 'og:url');
    og.setAttribute('content', canonical);
    og.setAttribute(MARK, '1');
    document.head.appendChild(og);

    const languages =
      hreflangLanguages && typeof hreflangLanguages === 'object' && Object.keys(hreflangLanguages).length
        ? hreflangLanguages
        : null;

    if (languages) {
      Object.entries(languages).forEach(([hreflang, href]) => {
        if (!hreflang || !href) return;
        const alt = document.createElement('link');
        alt.setAttribute('rel', 'alternate');
        alt.setAttribute('hreflang', hreflang);
        alt.setAttribute('href', String(href));
        alt.setAttribute(MARK, '1');
        document.head.appendChild(alt);
      });
    } else if (Array.isArray(hreflangAlternates)) {
      hreflangAlternates.forEach(({ hreflang, href }) => {
        if (!hreflang || !href) return;
        const alt = document.createElement('link');
        alt.setAttribute('rel', 'alternate');
        alt.setAttribute('hreflang', hreflang);
        alt.setAttribute('href', href);
        alt.setAttribute(MARK, '1');
        document.head.appendChild(alt);
      });
    }

    return () => {
      document.querySelectorAll(`head [${MARK}="1"]`).forEach((el) => el.remove());
    };
  }, [canonicalUrl, hreflangAlternates, hreflangLanguages]);

  return null;
}
